import { Component, ViewChild, inject, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';
import { AppSettings } from '@services/settings/app-settings.service';

@Component({
  selector: 'app-party-list',
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet, FormsModule, NgSelectModule, ListCardComponent],
  templateUrl: './party-list.component.html',
  styleUrl: './party-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class PartyListComponent {
  @ViewChild('ngSelect') ngSelect?: NgSelectComponent;

  parties = input<any[]>([]);
  isLoading = input(false);
  selectedUuid = input<string | null>(null);
  isPortalUser = input(false);
  ngPartiesData = input<any[]>([]);
  activeAdvancedFiltersCount = input(0);

  partiesSelected = model<any[]>([]);

  selectParty = output<any>();
  newParty = output<void>();
  filtersChange = output<void>();
  openFilters = output<void>();

  readonly appSettings = inject(AppSettings);

  onSelectParty(party: any): void {
    this.selectParty.emit(party);
  }

  onNewParty(): void {
    this.newParty.emit();
  }

  changeSelect(): void {
    this.filtersChange.emit();
  }

  onOpenFilters(): void {
    this.openFilters.emit();
  }
}
